import { yupResolver } from "@hookform/resolvers/yup"
import { TextFieldSaurus } from "components/inputs/text-field-saurus"
import { TextFieldSaurusProps } from "components/inputs/text-field-saurus/text-field-saurus-props"
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useFormCampoIdentificacaoValidation } from "./campo-identificacao-validation"
import { useStyles } from "./campo-identificacao-styles"
import { DefaultFormProps, DefaultFormRefs } from "components/forms/utils"

type TTipo = TextFieldSaurusProps['tipo'] | 'SEXO'

export interface CampoIdentificacaoProps extends DefaultFormProps<string> {
    name: string
    label: string
    tipo: TTipo
    isNotOpcional?: boolean
}

export const CampoIdentificacao = forwardRef<
    DefaultFormRefs<string>,
    CampoIdentificacaoProps
>(({ name, label, tipo, isNotOpcional, ...props }: CampoIdentificacaoProps, ref) => {
    const classes = useStyles()

    const refInput = useRef<HTMLInputElement>(null)
    const { formCampoIdentificacaoValidation } = useFormCampoIdentificacaoValidation(name, isNotOpcional)
    const [value, setValue] = useState('')

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } =
        useForm({
            mode: 'onChange',
            defaultValues: {
                [name]: value
            },
            resolver: yupResolver(formCampoIdentificacaoValidation)
        })

    const onSubmit = (model: any) => {
        props.onSubmit(model)
    }

    useImperativeHandle(ref, () => ({
        submitForm: async () => {
            await handleSubmit(onSubmit)();
        },
        resetForm: () => {
            setTimeout(() => {
                refInput.current?.focus();
            }, 500)
        },
        fillForm: (model: string) => {
            setValue(model)
            reset({ [name]: model })
        },
    }));

    useEffect(() => {
        setTimeout(() => {
            refInput.current?.focus();
        }, 500)
    }, [])

    if (tipo === "SEXO") return null

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <TextFieldSaurus
                        tipo={tipo}
                        inputRef={refInput}
                        className={classes.campo}
                        placeholder={`${label} ${isNotOpcional ? '' : '(Opcional)'}`}
                        variant="outlined"
                        color="primary"
                        autoFocus
                        error={Boolean(errors[name] && errors[name].message)}
                        helperText={
                            errors[name]
                                ? errors[name]?.message
                                : undefined
                        }
                        {...field}
                        fullWidth
                        allowSubmit
                        {...field}
                    />
                )}
            />
            <button type="submit" style={{ display: 'none' }}></button>
        </form>
    )
})